import React from 'react';
import './index.css';
import Container from '../layout/container';
import useWindowWidth from '../hooks/useWindowWidth';

export default function Footer() {
  const width = useWindowWidth();

  return (
    <div className="pf-ycp__footer">
      <Container
        style={{display: 'flex', alignItems: 'center', position: 'relative'}}
      >
        <div className="pf-ycp__footer-sponsored">
          Sponsored by
          <img
            alt=""
            src={require('../../assets/images/ycp/ico_stickercontest_wacomlogo.png')}
            onClick={() => window.open('https://www.wacom.com/zh-tw')}
            style={{cursor: 'pointer'}}
          />
        </div>
        <div className="pf-ycp__footer-right">
          Follow us on:
          <div className="pf-ycp__footer-media-icon">
            <a
              target="_blank"
              href={'https://www.facebook.com/tw.perfectcorp/'}
            >
              <img
                style={{marginLeft: width <= 800 && 0}}
                alt=""
                src={require('../../assets/images/ycp/ico_stickercontest_fb.png')}
              />
            </a>
            <a
              target="_blank"
              href={'https://www.instagram.com/youcamapps.tw/?hl=zh-tw'}
            >
              <img
                style={{marginRight: '30px'}}
                alt=""
                src={require('../../assets/images/ycp/ico_stickercontest_ig.png')}
              />{' '}
            </a>
          </div>
          {width > 800 && <> 2021© Perfect Corp. All Rights Reserved.</>}
        </div>
      </Container>{' '}
      {width <= 800 && (
        <div className="pf-ycp__footer-copy-right">
          2021© Perfect Corp. All Rights Reserved.
        </div>
      )}
    </div>
  );
}
